export default function closeModal(modal) {
    const closeButton = modal.querySelector('.btn-close');
    closeButton.click();
}